import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { PeFormResponseType } from '../../enums/pe-form-response-type.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'peFormResponseType',
  standalone: false
})
export class PeFormResponseTypePipe implements PipeTransform {
  public transform(value: PeFormResponseType): string {
    return getPeFormResponseType(value);
  }
}

export function getPeFormResponseType(value: PeFormResponseType): string {
  switch (value) {
    case PeFormResponseType.Create:
      return 'Create';
    case PeFormResponseType.Submit:
      return 'Submit';
    case PeFormResponseType.Accept:
      return 'Accept';
    case PeFormResponseType.AcceptReject:
      return 'Accept & Reject';
    default:
      throw new Error(`Unsupported value for PeFormResponseType: ${value}.`);
  }
}

export function getPeFormResponseTypeList(): IdName[] {
  return enumToList(PeFormResponseType, getPeFormResponseType).filter((x) => x.id > PeFormResponseType.Submit);
}
